import { authorized, unauthorized } from '../axios';
import {
  ALL_EMPLOYEE,
  BOOK_INSPECTION, CHANGE_PASSWORD,
  CONTACT_US, FILTER_PROPERTY, GET_BUY_PROPERTY, GET_COMPANY_DASHBOARD, GET_EMPLOYEE_DASHBOARD,
  GET_HOME_PROPERTY, GET_INSPECTED_PROPERTY,
  GET_SINGLE_PROPERTY, GET_USER_NOTIFICATION,
  GET_USER_PROPERTY, INDIVIDUAL_EMPLOYEE, NEWSLETTER,
  NEXT_OF_KIN, RENT_ASSIST, RESET_PASSWORD,
  USER_DATA, VERIFY_PASSWORD_OTP,
} from '../service-routes';
import {
  BookInspection,
  ChangePassword,
  ContactUs,
  NextOfKin, ObjectType, ResetPassword,
  UserData,
  VerifyPasswordOtp,
} from '../constant/serviceType';

export const getCompanyDashboard = (id: string | number) => {
  return unauthorized.get(`${GET_COMPANY_DASHBOARD}/${id}`);
};

export const getEmployeeDashboard = (id: string | number) => {
  return unauthorized.get(`${GET_EMPLOYEE_DASHBOARD}/${id}`);
};

export const getBuyProperty = (params: any) => {
  return authorized.get(GET_BUY_PROPERTY, {
    params: params,
  });
};

export const getInspectedProperty = (id: string | number) => {
  return authorized.get(`${GET_INSPECTED_PROPERTY}/${id}`);
};

export const getProperty = (number: number) => {
  return authorized.get('GET_PROPERTY', {
    params: { page: number },
  });
};

export const getCoOwnProperty = (params: any) => {
  return authorized.get('https://ekun.kekere.com/index.php/api/v1/featured-properties', {
    params: params,
  });
};

export const getAllEmployees = (id: string | number) => {
  return authorized.get(`${ALL_EMPLOYEE}/${id}`);
};

export const getEachEmployees = (id: string | number) => {
  return authorized.get(`${INDIVIDUAL_EMPLOYEE}/${id}`);
};

export const getSingleProperty = (id: string | number, data: { user_id: string }) => {
  return authorized.post(`${GET_SINGLE_PROPERTY}/${id}`, data);
};

export const getSingleCownProperty = (id: string | number) => {
  return authorized.get(`https://ekun.kekere.com/index.php/api/v1/property/${id}`);
};

export const postBookInspection = (payload: BookInspection) => {
  return authorized.post(BOOK_INSPECTION, payload);
};

export const getRentAssist = (payload: ObjectType) => {
  return authorized.post(RENT_ASSIST, payload );
};

export const postNextOfKin = (payload: NextOfKin) => {
  return authorized.post(NEXT_OF_KIN, payload);
};

export const getNextOfKin = (id: string | number) => {
  return authorized.get( `${NEXT_OF_KIN}/${id}`);
};

export const updateNextOfKin = (payload: NextOfKin) => {
  return authorized.put(NEXT_OF_KIN, payload);
};

export const postUserData = (payload: UserData, id: string | number) => {
  return authorized.post(`${USER_DATA}/${id}`, payload);
};

export const getUserData = (id: string | number) => {
  return authorized.get( `${USER_DATA}/${id}`);
};

export const postContactUs = (payload: ContactUs) => {
  return authorized.post(CONTACT_US, payload);
};

export const postNewsLetter = (payload: any) => {
  return authorized.post(NEWSLETTER, payload);
};

export const getFilteredData = (filter: any) => {
  return authorized.get(FILTER_PROPERTY, { params: filter });
};

export const getFeaturedProperty = (number: number) => {
  return authorized.get(GET_HOME_PROPERTY, {
    params: { page: number },
  });
};

export const getUserProperty = (id: string | number) => {
  return authorized.get(`${GET_USER_PROPERTY}/${id}`);
};


export const postChangePassword = (id: string | number, payload: ChangePassword ) => {
  return authorized.post( `${CHANGE_PASSWORD}/${id}`, payload);
};

export const postVerifyPasswordOtp = ( payload: VerifyPasswordOtp ) => {
  return authorized.post( `${VERIFY_PASSWORD_OTP}`, payload);
};


export const postResetPassword = (payload: ResetPassword ) => {
  return authorized.post( `${RESET_PASSWORD}`, payload);
};

export const getUserNotification = (id: string | number) => {
  return authorized.get(`${GET_USER_NOTIFICATION}/${id}`);
};
